import styled from 'styled-components';

export const Section = styled.section`
  width: 100%;
  padding: var(--space-xxxxl) var(--space-xxxl);
  background: linear-gradient(180deg, var(--white) 0%, var(--offWhite) 100%);
  @media screen and (max-width: 950px) {
    padding: var(--space-xxxl) var(--space-xl);
  }
  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) var(--space-m);
  }
`;

export const Container = styled.div`
  width: min(100%, 1280px);
  margin: 0 auto;
`;

export const SectionIntro = styled.div`
  max-width: 820px;
  /* margin: 0 auto var(--space-xxxl); */

  /* text-align: center; */

  @media screen and (max-width: 600px) {
    margin-bottom: var(--space-xxl);
  }
`;

export const Badge = styled.span`
  width: fit-content;

  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  margin-bottom: var(--space-m);
  padding: 0.45rem 0.8rem;

  border: 1px solid rgba(230, 139, 7, 0.2);
  border-radius: var(--borderRadiusButton);

  background: var(--yellow1);
  color: var(--grey6);

  font-family: var(--mainFont);
  font-size: 0.72rem;
  line-height: 1;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const BadgeDot = styled.span`
  width: 0.42rem;
  height: 0.42rem;

  flex-shrink: 0;

  border-radius: 50%;

  background: var(--orange5);
`;

export const Eyebrow = styled.p`
  margin: 0 0 var(--space-xs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.78rem;
  font-weight: 850;

  text-transform: uppercase;
  letter-spacing: 0.14em;
`;

export const Title = styled.h2`
  margin: 0;

  color: var(--grey7);

  /* font-family: var(--headerFont); */
  font-size: clamp(2.2rem, 4.5vw, 4rem);
  line-height: 1.03;
  font-weight: 800;

  letter-spacing: -0.04em;

  @media screen and (max-width: 600px) {
    font-size: clamp(2rem, 11vw, 3rem);
  }
`;

export const Description = styled.p`
  max-width: 700px;

  /* margin: var(--space-m) auto 0; */
  margin-bottom: var(--space-xl);

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 1rem;
  line-height: 1.8;
  font-weight: 500;

  @media screen and (max-width: 600px) {
    font-size: 0.95rem;
    line-height: 1.7;
  }
`;

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-l);

  @media screen and (max-width: 950px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 620px) {
    grid-template-columns: 1fr;
    gap: var(--space-m);
  }
`;

export const CategoryAction = styled.span`
  margin-top: auto;

  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  width: fit-content;
  max-width: 100%;

  color: var(--grey6);

  font-family: var(--mainFont);
  font-size: 0.85rem;
  line-height: 1.4;
  font-weight: 800;

  transition: color 180ms ease;

  span {
    display: inline-block;
    flex-shrink: 0;

    transition: transform 180ms ease;
  }
`;

export const CategoryCard = styled.article`
  min-width: 0;
  min-height: 320px;

  display: flex;
  flex-direction: column;

  padding: var(--space-xl);

  overflow: hidden;

  border: 1px solid var(--grey1);
  border-radius: var(--borderRadius);

  background: var(--cardBackground);
  box-shadow: var(--shadow-xs);

  transition:
    transform 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease,
    background 180ms ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(234, 154, 38, 0.35);
    background: var(--white);
    box-shadow: var(--shadow-md);
  }

  &:hover ${CategoryAction} {
    color: var(--orange5);
  }

  &:hover ${CategoryAction} span {
    transform: translateX(4px);
  }
`;
export const CategoryIcon = styled.div`
  width: 52px;
  height: 52px;
  display: grid;
  place-items: center;
  margin-bottom: var(--space-xl);
  padding: var(--space-s);
  border: 1px solid rgba(230, 139, 7, 0.14);
  border-radius: 50%;
  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);
  color: var(--orange5);
  font-size: 1.3rem;
  svg {
    display: block;
    transition: transform 180ms ease;
  }
`;

export const CategoryContent = styled.div`
  min-width: 0;

  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const CategoryEyebrow = styled.span`
  margin-bottom: var(--space-xs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.7rem;
  line-height: 1.3;
  font-weight: 850;

  text-transform: uppercase;
  letter-spacing: 0.11em;
`;

export const CategoryTitle = styled.h3`
  margin: 0;

  color: var(--grey7);

  /* font-family: var(--headerFont); */
  font-size: 1.4rem;
  line-height: 1.2;
  font-weight: 800;

  letter-spacing: -0.025em;
`;

export const CategoryDescription = styled.p`
  margin: var(--space-s) 0 var(--space-l);

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.9rem;
  line-height: 1.7;
  font-weight: 500;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;

  margin-top: var(--space-xxxl);
`;
